// extracted by css-extract-rspack-plugin
export default {"footer":"footer__pYT6W","footer__element":"footer__element__p5ljF","footer__element_link":"footer__element_link__sqlSn","footer__element_text":"footer__element_text__OJhXM"};